<p>
  Redirection en cours… <br/>
  Si vous n'êtes pas redirigez, cliquez ici <a href="{{ expandedLink }}">{{ expandedLink }}</a>
</p>
